import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';

import { showErrorToast } from '@hooks/showErrorToast';
import { apiClient } from '@utils';

export const useAdminPublishDutyExports = () => {
  const queryClient = useQueryClient();

  return apiClient.dutyExport.publishTaricDutyExport.useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin-catalogs-info'] });
      toast.success('Duty export published successfully');
    },
    onError: (error: unknown) => {
      showErrorToast(error, 'Failed to publish duty export');
    },
  });
};
